export const en = {
    Language: {
        english: "English",
        japan: "Japanese"
    },
    Menu: {
        home: "Home",
        dashboard: "Dashboard",
        territoryDefinition: "Territory Definition Maintenance",
        territoryAllocation: "Territory Allocation Maintenance",
        parentChildFacility: "Parent Child Facility Maintenance",
        parentChildChange: "Parent Child Change Request",
        organizationCustomer: "Organization Customer Inquiry",
        personCustomer: "Person Customer Inquiry",
        newCustomerRequest: "New Customer Request",
        customerRequestStatus: "Customer Request Status",
        customer: "Customer",
        territory: "Territory",
        logout: "Logout",
        downloads: "Downloads"
    },
    territoryDefinitionMaintenance: {
        currentMonth: "Current Month",
        system: "System",
        nextMonth: "Next Month",
        applyToNext: "Also apply to the next month",
        BU: "BU",
        division: "Division",
        branch: "Branch",
        salesOffice: "Sales Office",
        territorySetToMaintain: "Territory Set to Maintain",
        totalRecords: "Total number of records",
        territoryDefinitions: "Territory Definitions",
        updatedBy: "Updated by",
        lastUpdate: "Last updated at",
        blocks: "Blocks",
        facilitiesInSelectedBlock: "Facilities in the selected block",
        wwid: "WWID",
        checked: " - Checked",
        parChecked: " - Partially Checked",
        unChecked: " - Un-Checked"
    },
    territoryAllocationMaintenance: {
        territoryAllocations: "Territory Allocations",
        employee: "Employee *",
        nonMREmployee: "Non-MR employee is allocated",
        otherSalesOfficeMR: "MR in other sales office is allocated",
        employeeMessage: "The system is available on 8AM-12PM, 2PM-5PM and 8PM-11PM",
        employeeMessage2: "(limited to 8AM-12PM, 2PM-3PM on 4th business day of each month)"
    },
    parentChildFacilityMaintenance: {
        facilitySearch: "Facility search",
        mr: "MR",
        prefecture: "Prefecture",
        city: "City",
        code: "Code",
        name: "Name",
        type: "Type",
        noOfBeds: "No. of Beds",
        product: "Product",
        parentFacility: "Parent Facility",
        updatedBy: "Updated By",
        approvedBy: "Approved By",
        approvedOn: "Approved On",
        published: "Published",
        underReview: "Under Review"
    },
    parentChildChangeRequest: {
        id: "Submission ID",
        childFacility: "Child Facility",
        product: "Product",
        newParentFacility: "New Parent Facility",
        currentParentFacility: "Current Parent Facility",
        status: "Status",
        submittedBy: "Submitted By",
        submittedAt: "Submitted At",
        reviewedBy: "Reviewed By",
        reviewedAt: "Reviewed At",
        comments: "Comments"
    },
    OrganizationMenu: {
        organizationInfo: "Organization Info",
        affiliatedPersonnel: "Affiliated Personnel",
        childFacilities: "Child Facilities",
        parentFacilities: "Parent Facilities",
        allocatedEmployees: "Allocated Employees",
        hospitalFunctions: "Hospital Functions",
        prefectureFunctions: "Prefecture Functions",
        nursingInfo: "Nursing Info",
        kanjiFacilityName: "Facility Name (Kanji)",
        kanaFacilityName: "Facility Name (Kana)",
        kanjiPharmacist: "Supervising Pharmacist Name (Kanji)",
        kanaPharmacist: "Supervising Pharmacist Name (Kana)",
        integratedCustomerCode: "Integrated Customer Code / MDB Code",
        address: "Address",
        freeText: "Free Text Address",
        moreConditions: "More Conditions",
        allocatedSalesOffice: "Allocated sales Office",
        allocatedMR: "Allocated MRs",
        tel: "Tel",
        classifications: "Classifications",
        speciality: "Speciality",
        sortOrder: "Sort Order",
        byIntegratedCode: "By Integrated Customer Code",
        byName: "By Name",
        facilityName: "Facility Name",
        cutomerCode: "Integrated Customer Code / MDB Code",
        customerType: "Customer Type",
        facilityClassType: "Facility Class Type",
        affiliatedCode: "Affiliated Organization Customer Code",
        affiliatedName: "Affiliated Organization Customer Name",
        affiliatedDepartment: "Affiliated Department"
    },
    PersonMenu: {
        personInfo: "Person Customer Info",
        personCustomerDetails: "Person customer Details",
        personCustomerSearch: "Person Customer Search",
        kanjiPersonName: "Person Name (Kanji)",
        kanaPersonName: "Person Name (Kana)",
        speciality: "Speciality",
        facilityClassifications: "Facility Classifications",
        graduatedUniversity: "Graduated University",
        graduatedYear: "Graduated year",
        registeredYear: "Registered Year",
        sortOrder: "Sort Order",
        from : "From",
        to: "To",
        kanjiName: "Name (Kanji)",
        kanaName: "Name (Kana)",
        gender: "Gender",
        birthPlace: "Birth Place",
        birthDate: "Birth Date",
        dentistAssociation: "Doctor/Pharmacist/Dental Association",
        ultmarcPharmacistFlag: "Ultmarc Pharmacist Flag"
    },
    organizationDetails: {
        organizationCustomerDetails: "Organization Customer Details",
        noDM: "No DM Flag",
        organizationCustomerSearch: "Organization Customer Search",
        basicProfile: "Basic Profile",
        requesterName: "Requester Name",
        submittedDate: "Submitted Date",
        modifiedDate: "Modified Date",
        speciality: "Speciality",
        numberOfBeds: "Number of Beds",
        medicalArea: "Medical Area",
        maintenanceInfo: "Status/ Maintenance Info",
        orgCustomerChangeRequest: "Organization Customer Change Request",
        custNewChangeRequest: "Customer New/Change Request",
        confirmationLabel: "Customer New/Change Request(Confirmation)",
        completedLabel: "Customer New/Change Request(Completed)",
        submissionID: "Submission ID",
        unifiedCustomerCode: "Integrated Customer Code / MDB Code",
        customerType: "Customer Type",
        managementBody: "Management Body",
        postalCode: "Postal Code",
        suburb: "Suburb",
        street: "Street",
        addressLine: "Address Line",
        kanjiAddressLine: "Address Line (Kanji)",
        kanaAddressLine: "Address Line (Kana)",
        kanjiCustomerName: "Customer Name (Kanji)",
        kanaCustomerName: "Customer Name (Kana)",
        customerName: "Customer Name",
        representativePersonCode: "Representative Person Code",
        kanjiRepresentativePersonCode: "Representative Person Code (Kanji)",
        kanaRepresentativePersonCode: "Representative Person Code (Kana)",
        kanjiRepresentativePerson: "Representative Person Name (Kanji)",
        kanaRepresentativePerson: "Representative Person Name (Kana)",
        plannedOpenDate: "Planned Open Date",
        specialities: "Specialities",
        ultmarcRemark: "Remarks",
        ultmarcRemarkNote: "",
        reapplicationAcceptanceCode: "Reapplication Acceptance Code",
        plannedDeleteReason: "Planned Delete Reason",
        affiliatedCode: "Affiliated Organization Customer Code",
        affiliatedDepartment: "Affiliated Department",
        role: "Role",
        universityRole: "University Role",
        hospitalOwner: "Hospital Owner",
        ultmarcFacilityType: "Ultmarc Facility Type",
        managementBodyType: "Management Body Type",
        ultmarcHospitalType: "Ultmarc Hospital Type",
        hundredBedsType: "100 Beds Type",
        facilityFunctionType: "Facility Function Type",
        facilityClassType: "Facility Class Type",
        custNameLocal: "Customer Name Local Abbr",
        custNameLocalKana: "Customer Name Local Abbr Kana",
        kanjiAddress: "Address (Kanji)",
        kanaAddress: "Address (Kana)",
        facilityRepresentativePerson: "Facility Representative Person",
        supervisingPharmacist: "Supervising Pharmacist",
        maintenanceDate: "Maintenance Date Of Approved Number Of Beds",
        approvedBeds: "Approved Number Of Beds",
        general: "General",
        psychiatric: "Psychiatric",
        tuberculosis: "Tuberculosis",
        infectiousDisease: "Infectious Disease",
        recuperation: "Recuperation",
        other: "Other",
        total: "Total",
        secondMedicalArea: "2nd Medical Area",
        thirdMedicalArea: "3rd Medical Area",
        issuedDate: "Issued Date",
        psychiatricBeds: "Psychiatric Beds",
        tuberculosisBeds: "Tuberculosis Beds",
        infectiousDiseaseBeds: "Infectious Disease Beds",
        standardBeds: "Standard Beds",
        existingBeds: "Existing Beds",
        infectiousBeds: "Number Of Infectious Disease Beds",
        shortageBeds: "Shortage Number Of Beds",
        date: "Date",
        relatedUniversityCustomer: "Related University Customer",
        nursingHomeCustomer: "Nursing Home Medical Room Customer",
        drugStoreCustomer: "Drug Store Chain Head Office Customer",
        wholesalerCompany: "Wholesaler Company",
        plannedOpeningFlag: "Planned Opening Flag",
        closedFlag: "Closed Flag",
        wardClosure: "Ward Closure",
        reexaminationType: "Re-examination type",
        unknownAddress: "Unknown address type",
        closedYearMonth: "Closed / Opened Year Month",
        duplicatedCustomer: "Duplicated Customer",
        pharmacistCorrespondenceCode: "Pharmacist Correspondence Code",
        ultmarcModifiedDate: "Ultmarc Modified Date",
        ultmarcModificationType: "Ultmarc Modification Type",
        jobTitle: "Job Title",
        customerName: "Customer Name",
        customerType: "Customer Type",
        product: "Product",
        childFacility: "Child Facility",
        parentFacility: "Parent Facility",
        manager: "Manager",
        value: "Value",
        cancelledDate: "Cancelled Date",
        nursingType: "Nursing Type",
        numberOfWards: "Number of Wards",
        onDutyType: "On Duty Type",
        doctorAssociation: "Doctor Association",
        onDutyStartedYear: "On Duty Started Year",
        universityJobTitle: "University Job Title",
        retirementDate: "Retirement Info Received Date",
        ultmarcPlannedDeleteReason: "Ultmarc Planned Delete Reason",
        ultmarcRecordSuspensionType: "Ultmarc Record Supspension Type",
        ultmarcRecordSuspensionStartDate: "Ultmarc Record Supspension Start Date",
        ultmarcRecordSuspensionEndDate: "Ultmarc Record Supspension End Date",
        ultmarcProcessedDate: "Ultmarc Processed Date",
        flag: "Flag",
        approvedDate: "Approved/Issued Date",
        doubleCount: "Double Count",
        employeeSearch: "Employee Search",
        defaultAddressBlock: "Default Address Block",
        overrideOrgCustomerBlock: "Override Organization Customer Block",
        noticeLabel: "Notice"
    },
    personDetails: {
        personCustomerInfo: "Person Customer Info",
        personCustomerChangeRequest: "Person Customer Change Request",
        affiliatedFacilities: "Affiliated Facilities",
        affiliatedFacilitiesHistory: "Affiliated Facilities(History)"
    },
    customerRequestStatus: {
        searchCondition: "Search Condition",
        submissionData: "Submission Data",
        submissionType: "Submission Type",
        customerType: "Customer Type",
        submittedAt: "Submitted At",
        submittedBy: "Submitted By",
        submissionStatus: "Submission Status",
        submitted: "Submitted",
        item: "Item",
        submittedValue: "Submitted Value",
        responseFromUltmarc: "Response from Ultmarc",
        affiliationRequestStatus: "Customer Request Status(Affiliation)",
        orgRequestStatus: "Customer Request Status(Organization Customer)",
        personRequestStatus: "Customer Request Status(Person Customer)",
        sentToUltmarc: "Sent to Ultmarc",
        acceptedByUltmarc: "Accepted by Ultmarc",
        rejectedByUltmarc: "Rejected by Ultmarc",
        onHoldByUltmarc: "On-hold by Ultmarc",
        reflectedToCustomerMaster: "Reflected to Customer Master",
        resubmitted:"Resubmitted",
        cancelled: "Cancelled",
        new: "New",
        organizationCustomer: "Organization Customer",
        personCustomer: "Person Customer"
    },
    Buttons: {
        apply: "Apply",
        restore: "Restore",
        save: "Save",
        select: "Select",
        selectAll: "Select all",
        reset: "Reset",
        remove: "Remove",
        submit: "Submit",
        approve: "Approved",
        reject: "Rejected",
        close: "Close",
        search: "Search",
        add:"Add",
        next: "Next",
        previous: "Previous",
        resubmit: "Re-submit",
        edit: "Edit",
        withdraw: "Withdraw",
        back: "Back",
        ok: "OK",
        cancel: "Cancel",
        backToInquiry: "Back to Inquiry",
        requestAttributeChange: "Request Attribute Change",
        requestClosure: "Request Closure",
        requestAffiliationAttributeChange: "Request Affiliation Attribute Change",
        requestRetirement: "Request Retirement",
        requestNewAffiliation: "Request New Affiliation",
        loadMore: "LOAD MORE"
    },
    SalesMenu: {
        salesReports: "Sales Reports",
        dailySellout: "Daily Sellout Report Inquiry",
        dailySelloutCA: "Daily Sellout Report Inquiry (CA)",
        monthlySellout: "Monthly Sellout Report Inquiry",
        monthlySelloutCA: "Monthly Sellout Report Inquiry (CA)",
        selloutRotationByFacility: "Sellout Rotation Report Inquiry",
        selloutRotationByWholesaler: "Sellout Rotation Report Inquiry(CA)",
        emailSetting: "Daily Progress Email Delivery Setting Maintenance"
    },
    dailySellout: {
        processingDate: "Processing Date",
        personInCharge: "Person in charge",
        targetPersonName: "Target Person Name",
        wwidSpecify: "WWID specify",
        organizationName: "Organization Name",
        targetPersonInCharge: "Target person in charge",
        selectPersonInCharge: "Select person in charge",
        allSelection: "All select",
        preliminaryReport: "Preliminary report",
        previousBusinessDay: "Previous business day only",
        targetPeriod: "Target period",
        product: "Product",
        productL: "Product L",
        marketAuthorizationL: "Market Authorization L",
        formL: "Form L",
        formulationL: "Formulation L",
        packL: "Pack L",
        cityAndCounty: "City and County",
        productsNotInCharge: "Products not in charge",
        include: "Include",
        facilityClassification: "Facility classification",
        hundredFloorDivision: "100 floor division",
        twoHundredFloorDivision: "200 floor division",
        hundredBedClassification: "100 beds classification",
        twoHundredBedClassification: "200 beds classification",
        evaluationTargetClassification: "Evaluation target classification",
        functionClassification: "Function Classification",
        promotionSharingClassification: "Promotion Sharing Classification",
        doubleCount: "Double Count",
        copromotionFlag: "Janssen / Other company copromotion flag",
        wholesaleCorporationSelection: "Wholesale Corporation Selection",
        actualDigestionName: "Actual Digestion Parent Facility Name",
        deliveredFacilityName: "Delivered facility name",
        deliveryFacilityName: "Delivery Facility Name",
        childFacilityName: "Child Facility Name",
        accountingMonth: "Accounting Month",
        dueDate: "Due Date",
        numberOfBoxes: "Number of Boxes",
        drugPrice: "Drug Price",
        wholesaleCorporationName: "Wholesale Corporation Name",
        wholesaleBranch: "Wholesale Branch Name  Wholesale Branch Section Name",
        wholesaleBranchName: "Wholesale branch",
        slipNumber: "Slip Number",
        transactionClassification: "Transaction Classification",
        childFacilityHundredFloorDivision: "Child facility 100 beds classification",
        childFacilityFunctionClassification: "Child Facility Function Classification",
        parentFacilityPromotionClassification: "Parent Facility Promotion Sharing Classification",
        parentFacilityEvaluationClassification: "Parent facility evaluation target classification",
        doubleCountClassification: "Double Count Classification",
        display: "Display",
        months: "months",
        fixedMonth: "Fixed Month",
        wholesalerGroup: "Wholesaler Group",
        wholesalerOrganization: "Wholesaler Organization",
        legalEntity: "Legal Entity",
        area: "Area",
        county: "County",
        excelDownload: "Excel Download",
        choice: "Choice",
        list: "List",
        searchMembers: "Search Members",
        affiliation: "Affiliation",
        fixdeMonth: "Fixed Month",
        fixedMonthJPYear: "Fixed month(JP Calendar)",
        fixedMonthWholesaleYear: "Fixed month(Wholesale Calendar)",
        alertPeriod: "Alert Period",
        sortItems: "Sort Items",
        numericalItems: "Numerical Items",
        parentFacilityCode: "Parent Facility Code",
        parentFacilityName: "Parent facility name",
        nonDeliveryPeriod: "Non delivery period",
        receivedAndPaidQuantity: "Received and paid quantity",
        personInCharge: "Person in charge",
        jan: "January",
        feb: "February",
        march: "March",
        april: "April",
        may: "May",
        june: "June",
        july: "July",
        august: "August",
        sept: "September",
        oct: "October",
        nov: "November",
        dec: "December",
        wholesaler: "Wholesaler",
        wholesaleCorporation: "Wholesale Corporation",
        wholesaleManagementSalesDepartment: "Wholesale Management Sales Department",
        wholesaleSalesDepartment: "Wholesale Sales Department",
        wholesaleBranchSection: "Wholesale branch section",
        areaWholesaleParentFacility: "Area(Wholesale Parent Facility)",
        productType: "Product type",
        productInformation: "Product Information",
        salesCompanyProducts: "Sales Company Products",
        all: "All",
        inHouse: "In-house",
        otherCompany: "Other Company",
        currentYear: "Current year",
        lastYear: "Last year",
        yearBeforeLast: "Year before last",
        partitionAmount: "Partition amount",
        actualDeliveryAmount: "Actual delivery amount",
        corporationName: "Wholesale corporation name / Wholesale general sales department name / Wholesale sales department name / Wholesale branch name / Wholesale branch section name",
        employeeNumber: "Employee number",
        name: "Name",
        mailDeliveryTimezone: "Mail delivery time zone",
        companyWide: "Company-wide",
        salesDivision: "Sales division",
        district: "District",
        emailSettings: "Email settings",
        mailDeliveryOrgCode: "Mail Delivery Organization Code",
        mailDeliveryOrgName: "Mail Delivery Organization Name",
        mailDelivery: "Mail Delivery Organizational Hierarchy",
        modifiedDateTime: "Modified Date Time",
        modifiedEmployee: "Modified Employee",
        deliveryTimeRegistration: "Delivery Time Registration",
        returnToMenu: "Return to menu",
        achievementEmail: "Achievement Email Registration Screen",
        selectFromList: "Select from the list",
        parentfacilityName: "Parent facility name",
        packageQuantities: "Package quantities",
        salesAmount: "Sales amount",
        deliveredFacilityHundredFloorDivision: "Delivered facility 100 floor division",
        deliveredFacilityHundredBedsClassification: "Delivered facility 100 beds classification",
        salesAmountByWholesaler: "Sales Amount by wholesaler purchase price",
        salesAmountByCustomer: "Sales Amount by customer purchase price",
        customerPurchasePriceRate: "Customer purchase price rate",
        facilityType: "Facility type",
        districtName: "District name",
        breakTime: "Breaking news update time",
        breakingTime: "[Breaking news update time]",
        updateMessage: "* Update (reception of sales slip) is twice a day. The update time is as follows.",
        timeOne: "Around 9:30",
        timeTwo: "Around 13:30",
        listOne: "Alfressa, Mediceo, Toho Yakuhin, VITAL- NET Hokuyaku, Moroo, Nabelin, Iwabuchi Yakuhin, Okano Yakuhin, KSK Tomita Yakuhin, Miyazaki Onsendo Shoten, Ryuyaku",
        listTwo: "Alfresa, Suzuken, Suzuken Iwate, Sanki, Suzuken Okinawa Yakuhin, Shoyaku Hokuyaku, Moroo, Astis, Nakano Yakuhin, Shikoku  akugyo , Higashi Shichitakeda Yakuhin CoPro",
        masterAdmin: "Master Admin",
        systemError: "System is under maintenance",
        systemErrorMessage: "Currently system is under maintenance. Please close browser and login within production time",
        maintenance: "Maintenance", 
        packageQuantity: "Package Quantity",
        bulkQuantity: "Bulk Quantity",
        salesAmountByWholesalerPurchasePrice: "Sales Amount by wholesaler purchase price",
        salesAmountByCustomerPurchasePrice: "Sales Amount by customer purchase price",
        year: "Year",
        hempLaw: "Hemp law target classification",
        janssenProduct: "Janssen Product",
        mainProduct: "Main Product",
        delete: "Delete",
        salesOfficeName: "Sales office name",
        employeeWwid: "Employee WWID",
        unifiedCode: "Unified_Customer_Code_HCO",
        unifiedName: "Unified_Customer_Name_HCO",
        loginName: "Login User Name",
        selectSalesOffice: "Select the sales office where you want to receive emails",
        allSelectionConfirmation: "All selection is checked.",
        run: " Do you want to run?",
        timeConfirmation: "Are you sure to register"
    },
    annotations: {
        personInChargeAnnotation: "If you do not select a person in charge, please check it.",
        targetPeriodAnnotation: "Please select the target period.[Breaking news] You can quickly check the actual data captured after 20:00, which is the daily slip closing time, as 'breaking news'. It is updated to the latest status twice, around 9:30 and around 13:30 . Click ",
        here: "here",
        information: "for more information",
        products: "Please check if you want to display the details including products other than the one you are in charge of .",
        jpDuration: "Displays the current year, the previous year, and the two previous years in three columns in the JP fiscal year.",
        wholesaleDuration: "Displays the current year, the previous year, and the two previous years in three columns in the wholesale year.",
        target: "Displays the target period in one column.",
        mailMessage: "If you change “Mail delivery time zone”, all mail delivery times like company-wide, BU, Sales division, etc. will be changed.",
        applyNotice: 'You must fill in any one of the above fields.'
    },
    errorMessages: {
        VALID_KANJI_FACILITY_NAME: "Please add valid kanji facility name",
        VALID_KANA_FACILITY_NAME: "Please add valid kana facility name",
        VALID_FACILITY_NAME: "Please enter either facility name or customer code",
        PROVIDE_KANJI_FACILITY_NAME: "Please enter kanji facility name",
        VALID_INTEGRATED_CODE: "Please add valid integrated code",
        VALID_ADDRESS: "Please add valid address",
        VALID_NUMBER: "Please add valid number",
        VALID_POSTAL_CODE: "Please add valid postal code",
        VALID_NAME: "Please add valid name",
        PROVIDE_CUSTOMER_TYPE: "Please select customer type",
        PROVIDE_PREFECTURE: "Please select prefecture",
        PROVIDE_CITY: "Please select city",
        PROVIDE_SUBURB: "Please select suburb",
        PROVIDE_STREET: "Please select street",
        VALID_POSTAL_CODE: "Please add valid postal code",
        PROVIDE_KANJI_ADDRESS: "Please enter kanji address",
        VALID_KANJI_ADDRESS: "Please add valid kanji address",
        VALID_KANA_ADDRESS: "Please add valid kana address",
        VALID_KANJI_REPRESENTATIVE: "Please add valid kanji representative name",
        VALID_KANA_REPRESENTATIVE: "Please add valid kana representative name",
        PROVIDE_NUMBER_OF_BEDS: "Please enter number of beds",
        PROVIDE_SPECIALITY: "Please select atleast one speciality",
        VALID_REMARKS: "Please add valid remarks (no line breaks)",
        VALID_KANJI_CUSTOMER_NAME: "Please add valid kanji customer name",
        VALID_KANA_CUSTOMER_NAME: "Please add valid kana customer name",
        REQUIRE_SPACE_BETWEEN_LAST_FIRST_NAME: "Please add a space between last name and first name.",
        VALID_KANJI_PHARMACIST_NAME: "Please add valid kanji pharmacist name",
        VALID_KANA_PHARMACIST_NAME: "Please add valid kana pharmacist name",
        VALID_KANJI_PERSON_NAME: "Please add valid kanji person name",
        VALID_KANA_PERSON_NAME: "Please add valid kana person name",
        VALID_KANJI_NAME: "Please add valid kanji name",
        VALID_KANA_NAME: "Please add valid kana name",
        PROVIDE_KANJI_NAME: "Please enter kanji name",
        PROVIDE_AFFILIATED_CUSTOMER_CODE: "Please select affiliated organization customer code",
        PROVIDE_NUMBER: "Please enter number",
        VALID_KANJI_PHARMACIST: "Please add valid kanji pharmacist name",
        VALID_KANA_PHARMACIST: "Please add valid kana pharmacist name",
        PROVIDE_BU: "Please select BU",
        PROVIDE_DIVISION: "Please select division",
        PROVIDE_BRANCH: "Please select branch",
        PROVIDE_SALES_OFFICE: "Please select sales office",
        PROVIDE_TERRITORY: "Please select territory",
        PROVIDE_MR: "Please select MR",
        PROVIDE_DURATION: "Please select duration",
        
        CANCEL_REQUEST: "Do you want to cancel this request?",
        NOT_FOUND: "Request Not Found",
        SEARCH_REQUESTS: "To search for requests, please go to",
        NO_DATA: "No data found",
        REQUEST_NOT_SUBMITTED: "Request not submitted successfully !! Please try again.",
        REQUEST_NOT_SUBMITTED_US_EXISTED: "DCR request not saved. Error: Customer Affiliation already exists",
        REQUEST_CANCELLED: "Your request with Submission ID has been cancelled ",
        Login: "Login",
        SELECT_SALES_OFFICE: "Select the sales office where you want to receive emails",
        REGISTER: "Are you sure you want to register ?",
        SAVE_SUCCESS: "Saved successfully !",
        WARNING_RESTORE: "Are you sure, you want to restore this Territory Definition?",
        RESTORE_SUCCESS: "Restored successfully !",
        RESTORE_FAILED: "Restore failed !",
        PARENT_CHILD_RELATION: "Parent child product relations saved !!",
        DUPLICATE_RECORD: "Duplicate record exists !!",
        CHANGE: "Change",
        PERSON_CUSTOMER: "Person Customer",
        NON_MR_EMPLOYEE: "Non-MR employee is allocated",
        ALLOCATION_FAIL: "Employee should have the same role as selected TerritorySet's JobRole.",
        OTHER_SALES_OFFICE_MR: "MR in other sales office is allocated.",
        NO_FACILITIES: "No facilities found !!",
        REQUEST_SUBMITTED:  "Your request has been submitted with  ",
        YOUR_REQUEST: "Your request with Submission ID: ",
        CANCELLED: "has been cancelled",
        CUSTOMER_NOT_FOUND: "Customer not found",
        comment: "Comment",
        notice: "Notice to end users for Organization Customer Request. Expects admin user can configure this text.",
        VIEW_SUBMISSION_STATUS: "To view submission status, please go to",
        ultmarcRecordID: "Ultmarc Record ID",
        ultmarcFacilityTypeOne: "Ultmarc Facility Type(Level 1)",
        ultmarcFacilityTypeTwo: "Ultmarc Facility Type(Level 2)",
        medicalSpecialityOne: "Medical Speciality(Level 1)",

        //New
        AFFILIATION_EXISTS: "Affiliation already exists with this data",
        change: "Change",
        DOCTOR_PHARMACIST_REQUIRED_FIELD: "For new submission of doctor or hospital pharmacist, please enter either one of birth date, gradudated university, graduated year or registered year.",
        closure: "Closure"
    }
}